'use client';

import React, { createContext, useContext, useState } from 'react';

const BookmarkContext = createContext();

export const useBookmarkContext = () => useContext(BookmarkContext);

const toRelativePath = (url) => {
    if (!url || !url.startsWith('http')) return url;
    try {
        const u = new URL(url);
        return u.pathname + u.search;
    } catch {
        return url;
    }
};

export const BookmarkProvider = ({ children, initialBookmarks = [] }) => {
    const [bookmarkedPages, setBookmarkedPages] = useState(initialBookmarks);
    const [lastAddedUrl, setLastAddedUrl] = useState(null);

    const addBookmark = (bookmark) => {
        const normalizedUrl = toRelativePath(bookmark.url);
        const normalizedBookmark = { ...bookmark, url: normalizedUrl };
        setBookmarkedPages((prev) => {
            if (prev.some((b) => toRelativePath(b.url) === normalizedUrl))
                return prev;
            return [...prev, normalizedBookmark];
        });

        setTimeout(() => {
            setLastAddedUrl(normalizedUrl);

            setTimeout(() => {
                setLastAddedUrl(null);
            }, 1500);
        }, 1500);
    };

    const removeBookmark = (url) => {
        const normalizedUrl = toRelativePath(url);
        setBookmarkedPages((prev) =>
            prev.filter((b) => toRelativePath(b.url) !== normalizedUrl)
        );
    };

    return (
        <BookmarkContext.Provider
            value={{
                bookmarkedPages,
                addBookmark,
                removeBookmark,
                lastAddedUrl,
            }}>
            {children}
        </BookmarkContext.Provider>
    );
};
